import { LoadingOutlined } from "@ant-design/icons";
import veloprimeLogo from "../../assets/veloprime/logo-veloprime-horizontal-white.png";
import { useBroker } from "../../contexts/BrokerContext";

export const LoadingSession: React.FC = () => {
  const { currentBroker } = useBroker();

  return (
    <div className="loading-session">
      <img
        src={ veloprimeLogo}
        style={{height: 'auto', width: "200px"}}
        alt={"Velotax Logo"}
      />

      <LoadingOutlined />
    </div>










    
  );
};
